import React from 'react'
import Field from '../common/Field'
import i18n from 'i18n'

const formatDuration = (isoDuration) => {
  if (!isoDuration) return null
  const match = isoDuration.match(/PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/)
  if (!match) return isoDuration
  const hours = parseInt(match[1] || '0', 10)
  const minutes = parseInt(match[2] || '0', 10)
  const seconds = parseInt(match[3] || '0', 10)
  const parts = []
  if (hours > 0) parts.push(`${hours}h`)
  if (minutes > 0) parts.push(`${minutes}m`)
  if (hours === 0 && minutes === 0 && seconds === 0) return null
  if (seconds > 0 || parts.length === 0) parts.push(`${seconds}s`)
  return parts.join(' ')
}

const formatDistance = (meters) => {
  if (meters === undefined || meters === null || meters === 0) return null
  const km = (meters / 1000).toFixed(1)
  return `${km} km`
}

const t = (key) => i18n.t(`components.we_fitter.activity_segment_details.${key}`)

const WeFitterActivitySegmentDetails = (props) => {
  const sdos = props.data.structured_data_objects
  if (!sdos || sdos.length < 1) return <></>

  const dataRows = sdos[0].data_rows
  if (!dataRows || dataRows.length < 1) return <></>

  const data = dataRows[0]
  const hrSummary = data.heart_rate_summary

  return (
    <div className='sport-fields'>
      <Field key='duration' title={t('duration')} value={formatDuration(data.duration)} />
      <Field key='calories' title={t('calories')} value={data.calories ? `${Math.round(data.calories)}` : null} />
      <Field key='distance' title={t('distance')} value={formatDistance(data.distance)} />
      <Field key='steps' title={t('steps')} value={data.steps ? `${data.steps}` : null} />
      <Field key='avg_hr' title={t('avg_hr')} value={hrSummary?.average ? `${hrSummary.average} bpm` : null} />
      <Field key='max_hr' title={t('max_hr')} value={hrSummary?.max ? `${hrSummary.max} bpm` : null} />
    </div>
  )
}

export default WeFitterActivitySegmentDetails
